import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HttpModule } from '@angular/http';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ForgotPasswordComponent } from './Components/forgot-password/forgot-password.component';
import { LayoutContainerModule } from './modules/layoutModule/layout-container/layout-container.module';
import { VerifyOtpComponent } from './Components/verify-otp/verify-otp.component';
import { LoginModule } from './Components/login/login.module';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ShopLayoutContainerModule } from './modules/layoutShopModule/shop-layout/shop-layout-container.module';
import { HomePageService } from './services/home-page.service';
import { SeoHeaderComponent } from './modules/layoutShopModule/shop-components/seoHeader/seo-header.component';




@NgModule({
  declarations: [
    AppComponent,
    ForgotPasswordComponent,
    VerifyOtpComponent,
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    LoginModule,
    LayoutContainerModule,
    NgbModule,
    ShopLayoutContainerModule
  ],
  providers: [HomePageService],
  bootstrap: [AppComponent, SeoHeaderComponent],
})
export class AppModule { }
